import React from 'react';
import Typography from '@material-ui/core/Typography';
import ChatBubble from './svg/chat_bubble_illustration.svg';
import Button from '../ButtonComponent';
import { Colors, GlobalStyles } from '../../../utils';

const DmZeroState = ({ headline1, headline2, dm, onClick }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
      <img src={ChatBubble} alt="chat-bubble-icon" />
      <div style={{ marginTop: '32px' }}>
        <Typography
          style={{
            ...GlobalStyles.bodyRegular,
            color: Colors.grey1,
            textAlign: 'center',
          }}
        >
          {headline1}
        </Typography>
        <Typography
          style={{
            ...GlobalStyles.bodyRegular,
            color: Colors.grey1,
            textAlign: 'center',
          }}
        >
          {headline2}
        </Typography>
      </div>
      {dm && (
        <div style={{ marginTop: '16px' }}>
          <Button
            onClick={onClick}
            value="New message"
            buttonStyle={{
              backgroundColor: Colors.primaryColor,
              width: '136px',
              borderRadius: '5px',
            }}
          />
        </div>
      )}
    </div>
  );
};

export default DmZeroState;
